import {createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized} from "vue-router"
import {useUserStore} from "../store/user";
import UserLogin from "../pages/UserLogin.vue"
import UserRegister from "../pages/UserRegister.vue"
import UserVerify from "../pages/UserVerify.vue"
import UserResetPassword from "../pages/UserResetPassword.vue"
import UserChangePassword from "../pages/UserChangePassword.vue"
import Projects from "../pages/Projects.vue"
import ProjectTasks from "../pages/ProjectTasks.vue"
import ProjectSettings from "../pages/ProjectSettings.vue"
import ProjectUsers from "../pages/ProjectUsers.vue"
import NewProjectTaskType from "../pages/NewProjectTaskType.vue"
import TaskType from "../pages/TaskType.vue"
import NewTask from "../pages/task/NewTask.vue"
import UpdateTask from "../pages/task/UpdateTask.vue"
import TaskInfo from "../pages/task/TaskInfo.vue"
import PerformTaskInfo from "../pages/performTask/PerformTaskInfo.vue"
import UpdatePerformTask from "../pages/performTask/UpdatePerformTask.vue"
import UserSettings from "../pages/user/UserSettings.vue"
import ProjectTemplates from "../pages/ProjectTemplates.vue";
import CopyTask from "../pages/task/CopyTask.vue";
import Organizations from "../pages/Organizations.vue";
import OrganizationProjects from "../pages/OrganizationProjects.vue";
import OrganizationUsers from "../pages/OrganizationUsers.vue";
import OrganizationSettings from "../pages/OrganizationSettings.vue";
import SharedTaskInfo from "../pages/task/SharedTaskInfo.vue";
import SharedPerformTaskInfo from "../pages/performTask/SharedPerformTaskInfo.vue";
import NotFound from "../pages/NotFound.vue";

const ifNotAuthenticated = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const store = useUserStore()
    if (!store.loggedIn) {
        next()
        return
    }
    next('/')
}

const ifAuthenticated = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const store = useUserStore()
    if (store.loggedIn) {
        next()
        return
    }
    next({
        path: '/login',
        query: {returnTo: to.fullPath}
    })
}

const routes = [
    {
        path: '/login',
        component: UserLogin,
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: '/verify/:code',
        component: UserVerify,
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: '/password/:code',
        component: UserChangePassword,
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: '/register',
        component: UserRegister,
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: '/reset',
        component: UserResetPassword,
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: '/projects',
        component: Projects,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/organizations',
        component: Organizations,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/user/settings',
        component: UserSettings,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/organizations/:organizationId',
        component: OrganizationProjects,
        beforeEnter: ifAuthenticated,
        meta: {
            menu: "OrganizationMenu"
        },
    },
    {
        path: '/organizations/:organizationId/users',
        component: OrganizationUsers,
        name: "OrganizationUsers",
        meta: {
            menu: "OrganizationMenu"
        },
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/organizations/:organizationId/settings',
        component: OrganizationSettings,
        name: "OrganizationSettings",
        meta: {
            menu: "OrganizationMenu"
        },
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/task',
        component: SharedTaskInfo,
        name: "SharedTaskInfo",
        meta: {
            photos: true,
            photoLoaded: true,
        }
    },
    {
        path: '/performTask',
        component: SharedPerformTaskInfo,
        name: "SharedPerformTaskInfo",
        meta: {
            photos: true,
            photoLoaded: true,
        }
    },
    {
        path: '/projects/:projectId/tasks',
        component: ProjectTasks,
        name: "ProjectTasks",
        meta: {
            menu: "ProjectMenu"
        },
        children: [
            {
                path: 'new',
                component: NewTask,
            },
            {
                path: ':taskId',
                component: TaskInfo,
                name: "TaskInfo",
                meta: {
                    photos: true
                }
            },
            {
                path: ':taskId/perform/:performTaskId',
                component: PerformTaskInfo,
                name: "PerformTaskInfo",
                meta: {
                    photos: true
                }
            },
            {
                path: ':taskId/perform/:performTaskId/edit',
                component: UpdatePerformTask,
            },
            {
                path: ':taskId/edit',
                component: UpdateTask,

            },
            {
                path: ':taskId/copy',
                component: CopyTask,

            }
        ],
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/projects/:projectId/settings',
        component: ProjectSettings,
        name: "ProjectSettings",
        meta: {
            menu: "ProjectMenu"
        },
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/projects/:projectId/settings/templates',
        component: ProjectTemplates,
        name: "ProjectTemplates",
        meta: {
            menu: "ProjectMenu"
        },
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/projects/:projectId/users',
        component: ProjectUsers,
        name: "ProjectUsers",
        meta: {
            menu: "ProjectMenu"
        },
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/projects/:projectId/settings/taskType/new',
        component: NewProjectTaskType,
        name: "NewTaskType",
        meta: {
            menu: "ProjectMenu"
        },
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/projects/:projectId/settings/taskType/:taskTypeId',
        component: TaskType,
        name: "TaskType",
        meta: {
            menu: "ProjectMenu"
        },
        beforeEnter: ifAuthenticated,
    },
    { path: '/:catchAll(.*)*', component: NotFound }
]
 
const router = createRouter({
    routes,
    history: createWebHistory()
})

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    if (from.query.page && !to.query.page && to.path.includes("tasks")) {
        next({...to, query: {page: from.query.page}})
      } else {
        next()

      }
})

export default router;
